import { GET_HOME_PAGE_DATA_GETTER} from "@/store/storeconstants";

export default {
    [GET_HOME_PAGE_DATA_GETTER]: (state) => {
        return state.home
    },

    
};